/* istanbul ignore file */
enum ProductClassification {
    CareerTraining = 0,
    Fundamentals = 1,
}

enum ProductType {
    Unknown = 0,
    Ilc = 1,
    Spt = 2,
    Ctp = 3,
    Bundle = 6,
}

enum ProductOptionsText {
    Ilc = 'Instructor-Moderated',
    Spt = 'Self-Guided',
    Ctp = 'Instructor-led',
    IlcBundle = 'Instructor-Moderated',
    CtpBundle = 'Instructor-led',
}

enum SearchParamNames {
    Query = 'term',
    Page = 'page',
    CourseTypes = 'courseTypes',
    Topics = 'topics',
    SubTopics = 'subTopics',
    Sort = 'sort',
    Ext = 'ext',
}

enum SearchParamValues {
    CareerTraining = 'advanced-career-training',
    Fundamentals = 'fundamentals',
}

enum WebToCaseFormType {
    CurrentStudent = 'CurrentStudent',
    ProspectiveStudent = 'ProspectiveStudent',
}

enum WebToCaseFormScope {
    All = 'All',
    ACT = 'ACT',
    FUN = 'FUN',
    LoginOnly = 'LoginOnly',
}

export {
    ProductClassification,
    ProductType,
    ProductOptionsText,
    SearchParamNames,
    SearchParamValues,
    WebToCaseFormType,
    WebToCaseFormScope,
};
